// removed by extract-text-webpack-plugin
module.exports = {"textContainer":"src-components-OtherFactors-___index__textContainer___3ulJy","numbered":"src-components-OtherFactors-___index__numbered___Acj8L","lettered":"src-components-OtherFactors-___index__lettered___3SQCu","roman":"src-components-OtherFactors-___index__roman___3AJ1n","bulleted":"src-components-OtherFactors-___index__bulleted___1vfG7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OtherFactors/index.css
// module id = 1293
// module chunks = 3